export default "__VITE_ASSET__BFEfhH$v__"